import { render, staticRenderFns } from "./GoalWidgetType.vue?vue&type=template&id=2c5df2e0&"
import script from "./GoalWidgetType.vue?vue&type=script&lang=js&"
export * from "./GoalWidgetType.vue?vue&type=script&lang=js&"
import style0 from "./GoalWidgetType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports